var exports = {
  "modalBackdrop": "Modal.module__modalBackdrop___aUhHTG",
  "layer": "Modal.module__layer___aUhHTG",
  "backdropSlot": "Modal.module__backdropSlot___aUhHTG",
  "positionAbsoluteInsetZero": "Modal.module__positionAbsoluteInsetZero___aUhHTG",
  "backdropCentered": "Modal.module__backdropCentered___aUhHTG",
  "focusLock": "Modal.module__focusLock___aUhHTG",
  "surface": "Modal.module__surface___aUhHTG",
  "layerFullscreen": "Modal.module__layerFullscreen___aUhHTG",
  "layerFullscreenMobile": "Modal.module__layerFullscreenMobile___aUhHTG",
  "layerCentered": "Modal.module__layerCentered___aUhHTG",
  "root": "Modal.module__root___aUhHTG",
  "centeredOnMobile": "Modal.module__centeredOnMobile___aUhHTG",
  "rootAnimating": "Modal.module__rootAnimating___aUhHTG",
  "medium": "Modal.module__medium___aUhHTG",
  "small": "Modal.module__small___aUhHTG",
  "large": "Modal.module__large___aUhHTG",
  "xlarge": "Modal.module__xlarge___aUhHTG",
  "fullscreen": "Modal.module__fullscreen___aUhHTG",
  "slideInFromRight": "Modal.module__slideInFromRight___aUhHTG",
  "slideOutToRight": "Modal.module__slideOutToRight___aUhHTG",
  "mobileSlideIn": "Modal.module__mobileSlideIn___aUhHTG",
  "mobileSlideOut": "Modal.module__mobileSlideOut___aUhHTG",
  "layout": "Modal.module__layout___aUhHTG",
  "header": "Modal.module__header___aUhHTG",
  "light": "Modal.module__light___aUhHTG",
  "dark": "Modal.module__dark___aUhHTG",
  "footer": "Modal.module__footer___aUhHTG",
  "stretchButtons": "Modal.module__stretchButtons___aUhHTG",
  "headerInner": "Modal.module__headerInner___aUhHTG",
  "headerText": "Modal.module__headerText___aUhHTG",
  "content": "Modal.module__content___aUhHTG",
  "contentNoPadding": "Modal.module__contentNoPadding___aUhHTG",
  "screenReaderLabel": "Modal.module__screenReaderLabel___aUhHTG",
  "insetCloseButtonContainer": "Modal.module__insetCloseButtonContainer___aUhHTG",
  "insetCloseButton": "Modal.module__insetCloseButton___aUhHTG",
  "contentLayout": "Modal.module__contentLayout___aUhHTG",
  "description": "Modal.module__description___aUhHTG",
  "inputGroup": "Modal.module__inputGroup___aUhHTG",
  "formFooter": "Modal.module__formFooter___aUhHTG",
};

__webpack_require__.r(module.exports = exports);
